import styles from './FaqContainer.module.css';
import Faq from '../Faq';
import { useTranslation } from 'react-i18next';
import { useRemoteGet } from '@/hooks/useRemoteGet';
import { CustomFaqResourceService, FAQDTO } from '@/openapi';
import { useEffect, useState } from 'react';
import Loader from '@/components/UI/Loader';

interface FAQAreaProps {
	className?: string;
}

const FaqContainer = ({ className = '' }: FAQAreaProps) => {
	const { t } = useTranslation();

	const [category, setCategory] = useState('MINIMUM_CUSTOMER_REQUIREMENTS');

	const faqList = useRemoteGet<FAQDTO[]>({
		remoteMethod: async () => {
			return CustomFaqResourceService.getAllFaqFirstLevelByCategory({ category });
		},
		lazy: true
	});

	const changeCategory = (newCategory: string) => {
		setCategory(newCategory);
	};

	useEffect(() => {
		faqList.fetch();
	}, [category]);

	return (
		<div className={`${className} ${styles.faq_main_container}`}>
			<Loader visible={faqList.loading} />

			<div className={styles.title}>{t('faq.title')}</div>
			<div className={styles.description}>
				<p>{t('faq.description')}</p>
			</div>
			<div className={styles.subtitle}>{t('faq.message')}</div>
			<div className={styles.faq_category_container}>
				<button
					type={'button'}
					onClick={() => {
						changeCategory('MINIMUM_CUSTOMER_REQUIREMENTS');
					}}
					name={t('faq.category.cat1')}
					className={`${styles.faq_categoria_btn} ${category === 'MINIMUM_CUSTOMER_REQUIREMENTS' ? styles.selected : ''}`}
				>
					{t('faq.category.cat1')}
				</button>
				<button
					type={'button'}
					onClick={() => {
						changeCategory('GENERAL_CONDITIONS');
					}}
					name={t('faq.category.cat2')}
					className={`${styles.faq_categoria_btn} ${category === 'GENERAL_CONDITIONS' ? styles.selected : ''}`}
				>
					{t('faq.category.cat2')}
				</button>
				<button
					type={'button'}
					onClick={() => {
						changeCategory('PAYMENT_RULES');
					}}
					name={t('faq.category.cat3')}
					className={`${styles.faq_categoria_btn} ${category === 'PAYMENT_RULES' ? styles.selected : ''}`}
				>
					{t('faq.category.cat3')}
				</button>
				<button
					type={'button'}
					onClick={() => {
						changeCategory('MISCELLANEOUS');
					}}
					name={t('faq.category.cat4')}
					className={`${styles.faq_categoria_btn} ${category === 'MISCELLANEOUS' ? styles.selected : ''}`}
				>
					{t('faq.category.cat4')}
				</button>
			</div>

			{/* Single Faqs */}
			<div className={styles.single_faq_main_container}>
				{faqList.data?.map((faq: FAQDTO) => (
					<Faq
						key={faq.id}
						question={faq.question || ''}
						answer={faq.answer || ''}
						category={faq.category || ''}
						updatable={false}
					/>
				))}
			</div>
		</div>
	);
};

export default FaqContainer;
